import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ErrorIcon from "@mui/icons-material/Error";
import { Stack } from "@mui/material";

export default function InformationEmailPopUp(props) {
  const { open, sendItem, handleClose, title, handleInformationPopup } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Dialog
        className="user-filter-popup manage-user-filter"
        sx={{ width: "95%", marginLeft: "5rem" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        {/* <Stack
          sx={{ p: "26px 34px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography
            className="model-title"
            sx={{ 
              fontFamily: "Arial, sans-serif",  // Custom font family
              fontSize: "1.5rem",  // Custom font size
              color: "#333333",  // Custom font color
            }}
          >
            {title}
          </Typography>
        </Stack> */}
        <Box sx={{ padding: "25px" }}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <ErrorIcon
              fontSize="24px"
              style={{ color: "red", fontSize: "24px" }}
            />
            <Typography className="warning-title">Warning</Typography>
          </Stack>
          <Typography className="warning-text">
            Changing this email address will require the user to validate the
            new email address.
          </Typography>
          <Stack
            sx={{ mt: "24px" }}
            direction="row"
            spacing={0.5}
            alignItems="center"
          >
            <ErrorIcon
              fontSize="inherit"
              style={{ color: "#007FFF", fontSize: "24px" }}
            />
            <Typography className="warning-title">Note</Typography>
          </Stack>
          <Typography className="warning-text">
            This user will NOT be able to log in until the new email address is
            validated.
          </Typography>
        </Box>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            padding: "25px",
            paddingTop: "0px",
          }}
        >
          <Button
            className="filter-btn"
            onClick={() => {
              handleInformationPopup();
            }}
            sx={{
              fontFamily: "Roboto, sans-serif", // Custom font for button
              fontSize: "1rem", // Custom font size
              color: "#fff", // Button text color
              backgroundColor: "#007bff", // Button background color
              width: "74px",
            }}
          >
            Ok
          </Button>
          <Button
            className="cancel-btn"
            onClick={handleClose}
            sx={{
              fontFamily: "Roboto, sans-serif", // Custom font for button
              fontSize: "1rem", // Custom font size
              color: "#fff", // Button text color
              backgroundColor: "#6c757d", // Button background color
              width: "74px",
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
